import { render } from "./AudioTestItem.vue?vue&type=template&id=2cc829fa&scoped=true"
import script from "./AudioTestItem.vue?vue&type=script&lang=js"
export * from "./AudioTestItem.vue?vue&type=script&lang=js"

import "./AudioTestItem.vue?vue&type=style&index=0&id=2cc829fa&scoped=true&lang=scss"

import exportComponent from "/voc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc829fa"]])

export default __exports__